import * as React from 'react';
import b_ from 'b_';
import { StockTopCardFragment } from './__generated__/StockTopCardFragment';
import Header from './components/Header';
import { Footer } from './components/Footer';
import InvestSection from './components/InvestSection';
import { Stocks_StockStatus } from '../../../__generated__/globalTypes';

import './index.scss';

const b = b_.with('stock-top-card');

interface Props {
  product: StockTopCardFragment;
}

export const StockTopCard: React.FC<Props> = ({ product }) => (
  <div className={b()}>
    <div className={b('content')}>
      <Header stock={product} />
      <InvestSection
        symbol={product.symbol}
        id={product.id}
        disabled={product.status !== Stocks_StockStatus.PUBLISHED}
      />
      <Footer stock={product} />
    </div>
  </div>
);
